//
// Copyright (c) 2011-2018 by Curalate, Inc.
//

import { GALLERIES_ACTIONS } from '@galleries/constants/galleriesConstants';
import { SOURCE_FILTER_VALUES } from '@galleries/models/galleriesStateModel';
import { createAction } from '@utils/actions';
import { ReduxDispatch } from 'app/curalate.store';
import gaApi from 'app/initialization/ga/ga-api';

import { IAliasedDateRange } from '@components/date-range-picker/dateRangePickerModels';
function updateSearchFilter(searchText: string) {
  return createAction({
    type: GALLERIES_ACTIONS.UPDATE_SEARCH_VALUE,
    searchText,
  });
}

function updateSourceFilterValue(value: SOURCE_FILTER_VALUES) {
  return createAction({
    type: GALLERIES_ACTIONS.UPDATE_SOURCES_VALUE,
    value,
  });
}

function updateDateRangeFilterValue(dateRange: IAliasedDateRange) {
  return createAction({
    type: GALLERIES_ACTIONS.UPDATE_DATE_RANGE_VALUE,
    dateRange,
  });
}

export type GalleriesActionBarActionType = ReturnType<
  | typeof updateSearchFilter
  | typeof updateSourceFilterValue
  | typeof updateDateRangeFilterValue
>;

export const actions = {
  updateSearchFilter,
  updateDateRangeFilterValue,
  updateSourceFilter:
    (value: SOURCE_FILTER_VALUES) => (dispatch: ReduxDispatch) => {
      gaApi.recordEvent(
        gaApi.CATEGORY_GALLERIES,
        gaApi.ACTION_GALLERIES_MEDIA_FILTER_SELECTED,
        value,
      );

      if (value === SOURCE_FILTER_VALUES.PINNED) {
        gaApi.recordEvent(
          gaApi.CATEGORY_GALLERIES,
          gaApi.ACTION_PINNED_MEDIA_FILTER_PINNED_MEDIA,
          gaApi.LABEL_TOUCHPOINTS_GALLERIES,
        );
      }

      dispatch(updateSourceFilterValue(value));
    },
};
